import { createFeatureSelector, createSelector } from '@ngrx/store';

import { filterSucceededResource } from '@platform/shared/resource.state';
import { CoreState, CORE_STATE_FEATURE_KEY } from './core.state';

export const selectCoreFeature = createFeatureSelector<CoreState>(CORE_STATE_FEATURE_KEY);

export const selectNavigatedCustomerSpace = createSelector(selectCoreFeature, (state: CoreState) => state.customerSpace.navigated);

export const selectAdminCustomerSpace = createSelector(selectCoreFeature, (state: CoreState) => state.customerSpace.admin);

export const selectContacts = createSelector(selectCoreFeature, (state: CoreState) => state.customerSpace.contacts);

export const selectAllCustomerSpaces = createSelector(selectCoreFeature, (state: CoreState) => state.customerSpace.all);

export const selectCustomerSpaceCount = createSelector(selectCoreFeature, (state: CoreState) => state.customerSpace.count);

export const selectCustomerSpaceUsers = createSelector(selectCoreFeature, (state: CoreState) => state.customerSpace.users);

export const selectUserOrganizationUnits = createSelector(selectCoreFeature, (state: CoreState) => state.user.organizationUnits);

export const selectCreatedUser = createSelector(selectCoreFeature, (state: CoreState) => state.user.created);

export const selectUserProfile = createSelector(selectCoreFeature, (state: CoreState) => state.user.profile);

export const selectActiveUsers = createSelector(selectCoreFeature, (state: CoreState) => state.user.activeUsers);

export const selectUserOverview = createSelector(selectCoreFeature, (state: CoreState) => state.user.userOverview);

export const selectSharepointTemplateExtraction = createSelector(
  selectCoreFeature,
  (state: CoreState) => state.admin.sharepointTemplateExtraction,
);

export const selectTemplateActualisation = createSelector(selectCoreFeature, (state: CoreState) => state.admin.templateActualisation);

export const selectCustomerSpaceNotifications = createSelector(selectCoreFeature, (state: CoreState) => state.notification.customerSpace);

export const selectIsShowingNotifications = createSelector(
  selectCoreFeature,
  (state: CoreState) => state.notification.isShowingNotifications,
);

export const selectCurrentUserRepresenteeIds = createSelector(
  selectCoreFeature,
  (state: CoreState) => state.user.currentUserRepresenteeIds,
);

export const selectLoadedMobileUpload = createSelector(selectCoreFeature, (state: CoreState) => state.mobileUpload.loading);

export const selectMobileUploadUpload = createSelector(selectCoreFeature, (state: CoreState) => state.mobileUpload.upload);

export const selectNavigatedCustomerSpaceId = createSelector(selectNavigatedCustomerSpace, filterSucceededResource, (c) => c.data.id);

export const selectNavigatedCustomerSpaceName = createSelector(selectNavigatedCustomerSpace, filterSucceededResource, (c) => c.data.name);
